/**
 * Upgrade insecure media/image URLs so they satisfy CSP (https-only for remote origins).
 */

export function upgradeHttpToHttps(url) {
  const trimmed = String(url || '').trim();
  if (!trimmed) return '';
  if (trimmed.startsWith('//')) return `https:${trimmed}`;
  return trimmed.replace(/^http:\/\//i, 'https://');
}

/** img-src allows 'self' data: https: blob: */
export function cspSafeImageUrl(url) {
  const upgraded = upgradeHttpToHttps(url);
  if (!upgraded) return '';
  if (
    upgraded.startsWith('https:') ||
    upgraded.startsWith('data:') ||
    upgraded.startsWith('blob:') ||
    upgraded.startsWith('/')
  ) {
    return upgraded;
  }
  return '';
}

/** media-src allows 'self' https: blob: */
export function cspSafeMediaUrl(url) {
  const upgraded = upgradeHttpToHttps(url);
  if (!upgraded) return '';
  if (
    upgraded.startsWith('https:') ||
    upgraded.startsWith('blob:') ||
    upgraded.startsWith('/')
  ) {
    return upgraded;
  }
  return '';
}
